import React, { useState, useEffect, CSSProperties } from 'react';

interface PreloadedImageProps {
  src: string;
  alt: string;
  style?: CSSProperties;
  priority?: boolean;
}

const PreloadedImage: React.FC<PreloadedImageProps> = ({ 
  src, 
  alt, 
  style, 
  priority = false 
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (priority) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      document.head.appendChild(link);

      return () => {
        document.head.removeChild(link);
      };
    }
  }, [src, priority]);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <img
      src={src}
      alt={alt}
      style={{
        ...style,
        opacity: isLoaded ? 1 : 0,
        transition: 'opacity 300ms ease-in-out',
      }}
      onLoad={handleLoad}
      loading={priority ? 'eager' : 'lazy'}
    />
  );
};

export default PreloadedImage;